import { render, staticRenderFns } from "./SelectableMedia.vue?vue&type=template&id=f541dd38&"
import script from "./SelectableMedia.vue?vue&type=script&lang=ts&"
export * from "./SelectableMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports